module.exports = __webpack_public_path__ + "media/images/shared/logotypes/logo_kungsbacka-040463ac88a9bef959be1337a3d65a09.png";